// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

/*
 * The module's entries in the Back Office menu and the left sidebar.
 *
 * The sibling modules in `application-menu.vue` carry their titles as English
 * literals in the component, because that file predates the catalogues. New
 * user-facing strings go through the catalogue regardless, so these live here
 * and the component reads them — the menu is the first practice-management
 * sentence a user meets, and it would otherwise be the only one that cannot be
 * translated.
 */

export default {
    '$dir': 'ltr',

    'practiceManagement.menu.module.title': 'Practice Management',
    'practiceManagement.menu.module.description': 'Run the practice: client engagements, the work owed to each client, and their filing obligations.',

    'practiceManagement.menu.clients.title': 'Clients',
    'practiceManagement.menu.clients.description': "Review the practice's client engagements, invite a new client, and open a client's task board.",

    'practiceManagement.menu.compliance.title': 'Compliance',
    'practiceManagement.menu.compliance.description': "Track every client's filing obligations, and see which are due or overdue, on one board.",
};
